/* Display ordering only: move existing controls, preserving IDs and selections. */
(function () {
  const aliases = {XXXS: -1, '3XS': -1, XXS: 0, '2XS': 0, XS: 1, S: 2,
    SMALL: 2, M: 3, MEDIUM: 3, L: 4, LG: 4, LARGE: 4, XL: 5,
    XXL: 6, '2XL': 6, XXXL: 7, '3XL': 7, XXXXL: 8, '4XL': 8, '5XL': 9};
  function key(value) {
    const text = value.trim().toUpperCase().replace(/[–—]/g, '-');
    if (Object.hasOwn(aliases, text)) return [0, aliases[text], aliases[text]];
    const pair = text.split(/\s*[\/-]\s*/);
    if (pair.length === 2 && pair.every(x => Object.hasOwn(aliases, x))) {
      return [0, aliases[pair[0]], aliases[pair[1]]];
    }
    const numeric = text.match(/^(?:(?:UK|EU|US)\s*)?(\d+(?:\.\d+)?)(?:\s*(?:-|\/)\s*(\d+(?:\.\d+)?))?\s*(?:CM|MM)?$/);
    return numeric ? [1, Number(numeric[1]), Number(numeric[2] || numeric[1])] : null;
  }
  function order(values) {
    const keys = values.map(key);
    // Unknown or mixed sizing systems need review rather than guessed ordering.
    if (keys.some(k => !k) || new Set(keys.map(k => k[0])).size !== 1) return values.map((_, i) => i);
    const systems = values.map(v => (v.trim().toUpperCase().match(/^(UK|EU|US)\s*/) || [,''])[1]);
    if (new Set(systems).size > 1) return values.map((_, i) => i);
    return values.map((_, i) => i).sort((a,b) => keys[a][1]-keys[b][1] || keys[a][2]-keys[b][2]);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {key, order};
  if (typeof document === 'undefined' || window.csSizeOrderLoaded) return;
  window.csSizeOrderLoaded = true;
  function sortControls() {
    document.querySelectorAll('[data-cs-option-name]').forEach(group => {
      if (!/^(size|clothing size|shoe size|helmet size)$/i.test(group.dataset.csOptionName.trim())) return;
      if (group.tagName === 'SELECT') {
        const options = Array.from(group.options), selected = group.value;
        const positions = order(options.map(o => o.value));
        if (positions.every((n,i) => n===i)) return;
        positions.forEach(i => group.append(options[i])); group.value = selected;
      } else {
        const inputs = Array.from(group.querySelectorAll(':scope > input[type="radio"]'));
        const pairs = inputs.map(input => [input, Array.from(group.children).find(e => e.tagName === 'LABEL' && e.htmlFor === input.id)]);
        if (!pairs.length || pairs.some(p => !p[1])) return;
        const positions = order(inputs.map(i => i.value));
        if (positions.every((n,i) => n===i)) return;
        positions.forEach(i => group.append(...pairs[i]));
      }
    });
  }
  let pending = false;
  const observer = new MutationObserver(() => {
    if (!pending) { pending=true; requestAnimationFrame(() => {pending=false;sortControls();}); }
  });
  sortControls(); observer.observe(document.body,{childList:true,subtree:true});
})();
